import { shouldSkipBackgroundWork } from './pageActivity';

// Batch socket/focus events, serialize refreshes, and catch up when visible.
export const createVisibleRefresh = (refresh, delayMs = 800) => {
  let timer = null;
  let pending = false;
  let running = false;
  let disposed = false;

  const flush = async () => {
    timer = null;
    if (disposed || !pending || running || shouldSkipBackgroundWork()) return;
    pending = false;
    running = true;
    try {
      await refresh();
    } catch {
      // Background refresh errors are handled by the query or its caller.
    } finally {
      running = false;
      if (pending) arm();
    }
  };

  const arm = () => {
    if (!disposed && !running && timer === null && !shouldSkipBackgroundWork()) {
      timer = setTimeout(flush, delayMs);
    }
  };
  const schedule = () => {
    pending = true;
    arm();
  };
  const onVisible = () => {
    if (!shouldSkipBackgroundWork()) schedule();
  };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('online', onVisible);

  return {
    schedule,
    dispose: () => {
      disposed = true;
      if (timer !== null) clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('online', onVisible);
    },
  };
};
